import Tabs from "./Tabs";

export const tabs = {
    init: () => {
        const tabsElements = document.querySelectorAll(".sd-tabs-global");
        if (tabsElements) { 
            new Tabs(tabsElements); 
        }
    },
}

export default tabs;